import { createAction } from "@logicsoftware/redux-toolkit";
import { call, put, select, takeEvery } from "redux-saga/effects";
import { updateMissingSpaces } from "../missingSpacesSlice";
import { getAllSpaces } from "../selectors";
import { fetchMissingSpaces } from "./fetchMissingSpaces";

export const loadMissingSpaces = createAction("SPACES/FETCH_MISSING_SPACES", (spaceIds: number[]) => ({
    payload: spaceIds,
}));

export function* watchFetchMissingSpaces() {
    yield takeEvery(loadMissingSpaces, fetchMissingSpacesWorker);
}

function* fetchMissingSpacesWorker({ payload }: ReturnType<typeof loadMissingSpaces>) {
    const spaces: ReturnType<typeof getAllSpaces> = yield select(getAllSpaces);
    const missingSpaceIds = (payload || []).filter(spaceId => spaceId && !spaces[spaceId]);

    if (!missingSpaceIds.length) {
        return;
    }

    const result: Awaited<ReturnType<typeof fetchMissingSpaces>> = yield call(fetchMissingSpaces, missingSpaceIds);

    yield put(updateMissingSpaces(result));
}
